var map = {
	"./1.wav": 8305,
	"./2.wav": 5310,
	"./3.wav": 1320,
	"./4.wav": 9894,
	"./5.wav": 6381,
	"./6.wav": 919,
	"./7.wav": 8790,
	"./8.wav": 52,
	"./9.wav": 7366,
	"./adjust.wav": 2594,
	"./noise.wav": 6603,
	"./testnoise.wav": 2026
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4234;